<template>
  <div class="help-page">
    <div class="help-route-select">
      <router-link to="/cliente/monitores/cotacoes" class="help-route-select-text">
        Home
      </router-link>
      <span class="material-icons help-route-select-icon">play_arrow</span>
      <div class="help-route-select-text">Ajuda</div>
    </div>
    <div class="help-title">Ajuda</div>
    <div class="help-section">
      <span>Pesquisa vídeo</span>
      <div class="help-section-search">
        <input
          type="text"
          class="help-section-search-input"
          placeholder="Digite o nome do vídeo"
          v-model="searchQuery"
          @keyup.enter="searchVideos"
          ref="searchInput"
        />
        <button class="help-section-search-icon" @click="searchVideos">
          <span class="material-icons search-icon">search</span>
          <span class="search-title">Pesquisar</span>
        </button>
      </div>
    </div>
    <VideoTutorials :search-query="searchQuery" />
  </div>
</template>

<script>
import VideoTutorials from "./components/card-videos.vue";
export default {
  name: "Help",
  components: {
    VideoTutorials,
  },
  data() {
    return {
      searchQuery: "",
    };
  },
  methods: {
    searchVideos() {},
  },
};
</script>

<style scoped>
.help-page {
  font-size: 1vw;
}

.help-route-select {
  display: flex;
  align-items: center;
}

.help-route-select-text {
  font-weight: 400;
  font-size: 1.36em;
  line-height: 17px;
  color: #ababab;
  margin-right: 20px;
  cursor: pointer;
}

.help-route-select-icon {
  color: var(--primary-color);
  margin-right: 20px;
}

.help-title {
  font-weight: 600;
  font-size: 2em;
  line-height: 1.5em;
  letter-spacing: 0.15px;
  color: #605f5f;
  margin-top: 40px;
}

.help-section {
  display: flex;
  flex-direction: column;
  margin-top: 5vh;
}

.help-section span {
  font-size: 1.25em;
  line-height: 1.5em;
  letter-spacing: 0.15px;
  color: #898989;
}

.help-section-search {
  display: flex;
  align-items: center;
  margin-top: 16px;
  gap: 14px;
}

.help-section-search-input {
  width: 100%;
  max-width: 787px;
  height: 48px;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  color: #b3b3b3;
  font-size: 0.875rem;
  line-height: 1.5em;
  letter-spacing: 0.15px;
  padding: 0 16px;
  text-indent: 0;
}

.help-section-search-input:focus {
  outline: none;
}
.help-section-search-input::placeholder {
  padding-left: 8px;
  transition: padding-left 0.3s ease;
}

.help-section-search-input:focus::placeholder {
  padding-left: 0;
}

.help-section-search-icon {
  width: 100%;
  max-width: 167px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  background-color: transparent;
  gap: 8px;
}

.help-section-search-icon .search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--primary-color);
  font-size: 1.2em;
  font-weight: 600;
}

.search-title {
  font-weight: 600;
  color: #404040;
  font-size: 1em;
}

@media only screen and (max-width: 1000px) {
  .help-page {
    font-size: 1.2vw;
  }

  .help-section-search {
    max-width: 85%;
  }

  .help-section-search-input {
    width: 65%;
  }

  .help-section-search-icon {
    width: 20%;
  }
}

@media only screen and (max-width: 850px) {
  .help-page {
    font-size: 2vw;
  }

  .help-section-search {
    max-width: 100%;
  }

  .help-section-search-input {
    width: 70%;
  }

  .help-section-search-icon {
    width: 30%;
  }

  .help-section-search-icon .search-icon {
    font-size: 1em;
  }

  .search-title {
    font-size: 0.8em;
  }
}

@media only screen and (max-width: 550px) {
  .help-page {
    font-size: 3vw;
  }

  .help-section-search-input {
    width: 100%;
  }

  .help-section-search-icon {
    width: 100%;
  }
}
</style>
